/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const supportBlockerV4NameSchema = z
  .enum([
    'LockedOut',
    'LoginCodeRequired',
    'MustChangePassword',
    'MustChangeEmail',
    'MustAcceptUserTerms',
    'MustAcceptUserDataPolicy',
    'MustAcceptOrgTerms',
    'MustAcceptOrgDataPolicy',
    'ConfirmInternDetails',
    'ConfirmAgreementDetails',
  ])
  .describe('Member names of SupportBlockerV4.')
